
import axios from "axios";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY
export const getJsonMenu = async () => {
    try {
      
        
        const res = await axios.get(`${urlApi}/menu/jsonMenu`)
        return res.data;
    } catch (error) {
        console.error("Error fetching menu data:", error);
        return [];
    }

}